module.exports = __webpack_public_path__ + "static/car-history-7a33cb9f61123818e7926defadd289de.svg";